import classNames from "classnames";
import i18next from "i18next";
import React, { useState, useEffect, useContext, useRef } from "react";
import "./LanguageSelection.css";
import { StatusContext } from "../../contexts/Status.context";
import LoadingScreen from "./LoadingScreen";
import axios from "axios";

function useClickOutside(ref: any, callback: Function) {
  const handleClick = (e: any) => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  });
}

const LanguageSelection = () => {
  const langList = [
    {
      image: "en.svg",
      lang: "en",
    },
    {
      image: "nl.png",
      lang: "nl",
    },
    {
      image: "es.svg",
      lang: "es",
    },
    {
      image: "fr.svg",
      lang: "fr",
    },
    {
      image: "he.jpg",
      lang: "he",
    },
    {
      image: "pt.svg",
      lang: "pt",
    },
    {
      image: "sv.png",
      lang: "sv",
    },
    {
      image: "no.webp",
      lang: "no",
    },
    {
      image: "it.jpg",
      lang: "it",
    },
    {
      image: "sk.png",
      lang: "sk",
    },
    {
      image: "ja.svg",
      lang: "ja",
    },
    {
      image: "pl.png",
      lang: "pl",
    },
    {
      image: "da.png",
      lang: "da",
    },
    {
      image: "lt.png",
      lang: "lt",
    },
    {
      image: "tr.svg",
      lang: "tr",
    },
    {
      image: "de.jpg",
      lang: "de",
    },
    {
      image: "hu.png",
      lang: "hu",
    },
    {
      image: "zh.svg",
      lang: "zh",
    },
  ];

  const langSelectRef = useRef(null);

  const { lang, setLang, setTranslations } = useContext(StatusContext);
  const [isLangLoading, setIsLangLoading] = useState<boolean>(false);
  const [isLangSelection, setIsLangSelection] = useState<boolean>(false);

  useEffect(() => {
    getAllTranslations();
  }, []);

  useClickOutside(langSelectRef, () => {
    setIsLangSelection(false);
  });

  const handleLang = (lang: string) => {
    if (isLangSelection) {
      handleTranslation(lang);
      setIsLangSelection(false);
    } else {
      setIsLangSelection(true);
    }
  };

  const getAllTranslations = async () => {
    const langs = langList.map((item) => item.lang);
    let langJson: any = {};
    for (let i = 0; i < langs.length; i++) {
      const lang = langs[i];
      try {
        const apiKey1 = "YG7nb7zXzkikJboO0NU_uw"; //paulmartin.pm1125@gmail.com
        const { data: data1 } = await axios.get(
          `https://api.i18nexus.com/project_resources/translations/${lang}/default?api_key=${apiKey1}`
        );
        const apiKey2 = "kJ0JXnqxg8mlZ3PtGvQ61w"; //despicableme.feloniousgru@gmail.com
        const { data: data2 } = await axios.get(
          `https://api.i18nexus.com/project_resources/translations/${lang}/default?api_key=${apiKey2}`
        );
        const apiKey3 = "QXyQqM1uUTDCe5lfK_9wqQ"; //mykolas922@gmail.com
        const { data: data3 } = await axios.get(
          `https://api.i18nexus.com/project_resources/translations/${lang}/default?api_key=${apiKey3}`
        );

        langJson[lang] = { ...data1, ...data2, ...data3 };
      } catch (error) {}
    }
    localStorage.setItem("lang", JSON.stringify(langJson));
  };

  const handleTranslation = async (lang: string) => {
    setIsLangLoading(true);
    let langJson: any = {};

    try {
      const apiKey1 = "YG7nb7zXzkikJboO0NU_uw"; //paulmartin.pm1125@gmail.com
      const { data: data1 } = await axios.get(
        `https://api.i18nexus.com/project_resources/translations/${lang}/default?api_key=${apiKey1}`
      );
      const apiKey2 = "kJ0JXnqxg8mlZ3PtGvQ61w"; //despicableme.feloniousgru@gmail.com
      const { data: data2 } = await axios.get(
        `https://api.i18nexus.com/project_resources/translations/${lang}/default?api_key=${apiKey2}`
      );
      const apiKey3 = "QXyQqM1uUTDCe5lfK_9wqQ"; //mykolas922@gmail.com
      const { data: data3 } = await axios.get(
        `https://api.i18nexus.com/project_resources/translations/${lang}/default?api_key=${apiKey3}`
      );

      langJson[lang] = { ...data1, ...data2, ...data3 };
    } catch (error) {}
    setTranslations(langJson);
    setLang(lang);
    setIsLangLoading(false);
  };

  return (
    <>
      <div
        className={`lang ${isLangSelection && "active"}`}
        ref={langSelectRef}
      >
        <div>
          <ul>
            {langList.map((item, index) => (
              <li
                key={index}
                className={classNames({ select: lang == item.lang })}
                onClick={() => handleLang(item.lang)}
              >
                <img
                  width="40"
                  height="40"
                  src={`/assets/images/lang/${item.image}`}
                  alt={item.lang}
                  loading="lazy"
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
      {isLangLoading && <LoadingScreen />}
    </>
  );
};

export default LanguageSelection;
